<template>
  <v-card color="#F2F4F7" flat elevation="0" class="my-5">
    <v-card-text>
      <v-container class="py-10">
        <h2>
          Assessment
          <span :style="`color: ${passingColor}`">{{
            result.passed ? 'Passed' : 'Failed'
          }}</span>
        </h2>
        <h6 v-if="!quiz.is_checklist_only">
          You scored {{ result.total_score }} out of
          {{ quiz.total_score }} points
        </h6>
        <h1 size="large" :style="`color: ${passingColor}`">
          {{ result.average }}%
        </h1>
        <h6 v-if="!quiz.is_checklist_only">
          With a passing score of {{ quiz.passing_score }} points (Passing Rate
          of {{ quiz.passing_rate }}%)
        </h6>
        <p>
          User Passing Average is:
          <span :style="`color: ${passingAverageColor}`"
            >{{ quiz.passing_average }}%</span
          >
        </p>
        <div>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            @click="proceedNext"
            color="primary"
            class="mt-5"
            small
          >
            Continue <i class="fal fa-arrow-right ml-1" />
          </v-btn>
        </div>
        <div>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            @click="retakeQuiz"
            class="mt-3"
            color="error"
            small
          >
            Retake Assessment
          </v-btn>
        </div>
        <div>
          <v-btn
            v-show="false"
            @click="toggleSendResultDialog"
            class="mt-3"
            small
          >
            Email Result
          </v-btn>
        </div>
        <template v-if="!quiz.is_checklist_only">
          <div class="mt-7">
            <h6>
              You answered {{ numberOfCorrectQuestions }} out of
              {{ result.total_number_of_questions }} questions correctly
            </h6>
          </div>
          <div class="mt-3">
            <v-card
              class="mt-1"
              color="#F9FAFB"
              elevation="0"
              flat
              outlined
              v-for="(question, i) in questionForm"
              :key="i"
            >
              <v-card-title class="text-left">
                <v-icon
                  v-if="isQuestionCorrect(question)"
                  color="green"
                  class="mr-2"
                  small
                >
                  fas fa-check
                </v-icon>
                <v-icon v-else color="red" class="mr-2" small>
                  fas fa-times
                </v-icon>
                {{ i + 1 }}.) {{ question.value }}
              </v-card-title>
              <v-card-subtitle class="text-left">
                Points:
                <strong>{{
                  isQuestionCorrect(question) ? question.point_value : 0
                }}</strong>
              </v-card-subtitle>
              <v-card-text>
                <v-container fluid class="pt-0">
                  <div
                    v-if="
                      question.type === 'multiple_choice' ||
                      question.type === 'true_false'
                    "
                  >
                    <div v-if="question.is_multiple">
                      <template v-for="(answer, ai) in question.answers">
                        <v-checkbox
                          disabled
                          :loading="isLoading"
                          :color="answer.is_correct === 1 ? 'success' : 'error'"
                          v-model="question.user_answer"
                          :label="answer.value"
                          :value="answer.id"
                          hide-details
                        >
                          <template #label>
                            <span v-if="answer.is_correct">
                              <strong style="color: black !important">
                                {{ answer.value }}
                              </strong>
                              <em v-if="question.description">
                                - {{ question.description }}
                              </em>
                            </span>
                            <del v-else>
                              {{ answer.value }}
                            </del>
                          </template>
                        </v-checkbox>
                      </template>
                    </div>
                    <template v-else>
                      <v-radio-group v-model="question.user_answer[0]">
                        <template v-for="(answer, ai) in question.answers">
                          <v-radio
                            disabled
                            :loading="isLoading"
                            :color="
                              answer.is_correct === 1 ? 'success' : 'error'
                            "
                            :key="ai"
                            :label="answer.value"
                            :value="answer.id"
                          >
                            <template #label>
                              <span v-if="answer.is_correct">
                                <strong style="color: black !important">
                                  {{ answer.value }}
                                </strong>
                                <em v-if="question.description">
                                  - {{ question.description }}
                                </em>
                              </span>
                              <del v-else>
                                {{ answer.value }}
                              </del>
                            </template>
                          </v-radio>
                        </template>
                      </v-radio-group>
                    </template>
                  </div>
                  <div v-if="question.type === 'checklist'">
                    <template v-for="(answer, ai) in question.answers">
                      <v-checkbox
                        disabled
                        :loading="isLoading"
                        v-model="question.user_answer"
                        :label="answer.value"
                        :value="answer.id"
                        hide-details
                        color="success"
                      >
                        <template #label>
                          <span
                            :style="
                              answer.is_correct
                                ? 'color: green;'
                                : 'color: red;'
                            "
                          >
                            {{ answer.value }}
                          </span>
                        </template>
                      </v-checkbox>
                    </template>
                  </div>
                </v-container>
              </v-card-text>
              <template v-if="false">
                <v-divider color="gray" class="mx-4"></v-divider>
                <v-card-text class="text-left">
                  <v-container fluid>
                    <i>{{ question.description }}</i>
                  </v-container>
                </v-card-text>
              </template>
            </v-card>
          </div>
        </template>
        <template v-else>
          <div class="mt-3">
            <v-card
              class="mt-1"
              color="#F9FAFB"
              elevation="0"
              flat
              outlined
              v-for="(question, i) in questionForm"
              :key="i"
            >
              <v-card-title class="text-left"
                >{{ question.value }}
              </v-card-title>
              <v-card-text>
                <v-container fluid class="pt-0">
                  <template v-for="(answer, ai) in question.answers">
                    <v-checkbox
                      disabled
                      :loading="isLoading"
                      v-model="question.user_answer"
                      :label="answer.value"
                      :value="answer.id"
                      hide-details
                      color="success"
                    >
                      <template #label>
                        <span
                          :style="
                            answer.is_correct ? 'color: green;' : 'color: red;'
                          "
                        >
                          {{ answer.value }}
                        </span>
                      </template>
                    </v-checkbox>
                  </template>
                </v-container>
              </v-card-text>
              <template v-if="question.description">
                <v-divider color="gray" class="mx-4"></v-divider>
                <v-card-text class="text-left">
                  <v-container fluid>
                    <i>{{ question.description }}</i>
                  </v-container>
                </v-card-text>
              </template>
            </v-card>
          </div>
        </template>
      </v-container>
    </v-card-text>
    <send-quiz-result-dialog
      @returnEmail="sendResult"
      :close-dialog="closeAllDialogs"
      :show-dialog="showSendResultDialog"
    />
    <loading-dialog
      :loading-dialog="showLoadingDialog"
      :message="sendingMessage"
    />
  </v-card>
</template>

<script>
import {
  filter as _filter,
  find as _find,
  findIndex as _findIndex,
  forOwn as _forOwn,
  isEmpty as _isEmpty,
  each as _each,
  some as _some,
  forEach as _forEach,
  isEqual as _isEqual,
  sortBy as _sortBy,
  map as _map,
} from 'lodash-es';
import SendQuizResultDialog from '@/components/client-lms/dialog-box/SendQuizResultDialog';
import LoadingDialog from '@/components/course-certification/includes/LoadingDialog';

export default {
  name: 'ResultQuiz',
  components: {
    SendQuizResultDialog,
    LoadingDialog,
  },
  props: {
    quiz: {
      type: Object,
      required: true,
    },
    result: {
      type: Object,
      required: true,
    },
    retakeQuiz: {
      type: Function,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    proceedNext: {
      type: Function,
      required: true,
    },
  },

  data: () => ({
    showSendResultDialog: false,
    sendingMessage: 'Sending Result...',
    showLoadingDialog: false,
  }),

  computed: {
    passingColor() {
      return this.result.passed ? 'green' : 'red';
    },
    questionForm() {
      const form = this.result ? JSON.parse(this.result.quiz_form) : null;

      if (form) {
        _each(form, (question, key) => {
          question.is_correct = this.isQuestionCorrect(question);
        });
      }

      return form;
    },
    numberOfCorrectQuestions() {
      const correctAnswers = _map(
        _filter(this.questionForm, { is_correct: true }),
        'id'
      );

      return correctAnswers.length;
    },
    passingAverageColor() {
      if (this.quiz.passing_average <= 50) {
        return 'red';
      }

      if (this.quiz.passing_average <= 75) {
        return 'yellow';
      }

      if (this.quiz.passing_average <= 100) {
        return 'green';
      }
    },
  },

  methods: {
    isQuestionCorrect(question) {
      const correctAnswers = _map(
        _filter(question.answers, { is_correct: 1 }),
        'id'
      );
      const userAnswers = _map(question.user_answer);

      return _isEqual(correctAnswers.sort(), userAnswers.sort());
    },
    toggleSendResultDialog() {
      this.showSendResultDialog = true;
    },
    closeAllDialogs() {
      this.showSendResultDialog = false;
      this.showLoadingDialog = false;
    },
    sendResult(email) {
      this.closeAllDialogs();
      this.sendingMessage = 'Sending Result to ' + email + ' ...';
      this.showLoadingDialog = true;
      this.axios
        .post('/client/lms/sendresult/quiz', {
          email: email,
          unit_id: this.result.unit_id,
          user_score: this.result.total_score,
          total_score: this.quiz.total_score,
          user_average: this.result.average,
          passing_rate: this.quiz.passing_rate,
          passing_score: this.quiz.passing_score,
          passed: this.result.passed,
          correct_questions: this.numberOfCorrectQuestions,
          questions: this.questionForm,
        })
        .then(({ data }) => {
          if (data.success) {
            this.$notify(
              'success',
              'Assessment Result sent to ' + email + ' successfully.'
            );
          }
        })
        .catch()
        .finally(() => {
          this.closeAllDialogs();
        });
    },
  },
};
</script>

<style scoped></style>
